<template>
  <v-img
    v-if="profilePhoto"
    :src="profilePhoto"
    alt="Profile Photo"
    size="small"
  />
  <div
    v-else-if="userProfileInitials"
    :aria-hidden="!userProfileInitials"
    class="pa-2 font-weight-bold text-white"
  >
    {{ userProfileInitials }}
  </div>
</template>
<script setup>
import { useStore } from 'vuex';

import { toAcronym } from '@/shared/services/string-utils';

const store = useStore();
const profilePhoto = computed(() => store.state.profile.photo);
const userProfileInitials = computed(() => toAcronym(store.state.profile.name));
</script>
